import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '@shared/services/common-service';
import { GetMotivoTransicaoResponse } from '@shared/services/responses/servico/get-motivo-transicao.response';
import { CreateMotivoTransicaoResponse } from '@shared/services/responses/servico/create-motivo-transicao.response';
import { MotivoTransicaoRequest } from '@shared/services/requests/servico/motivo-transicao.request';
import { MotivoTransicaoAtivoRequest } from '@shared/services/requests/servico/motivo-transicao-ativo.request';
import { ReturnStruct } from '@shared/services/structs/return.struct';

@Injectable({
  providedIn: 'root',
})
export class MotivoTransicaoService extends CommonService {
  private readonly apiUrl: string = environment.urlApiServico + 'MotivoTransicao';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public getAll(
    nome: string = '',
    isAtivo: boolean | null = null,
    pagina: number = 0,
    tamanhoPagina: number = 20
  ): Observable<GetMotivoTransicaoResponse> {
    let params = new HttpParams()
      .set('pagina', pagina.toString())
      .set('tamanhoPagina', tamanhoPagina.toString());

    if (nome) {
      params = params.set('nome', nome);
    }
    if (isAtivo !== null && isAtivo !== undefined) {
      params = params.set('isAtivo', isAtivo.toString());
    }

    return this.httpClient
      .get<GetMotivoTransicaoResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
      .pipe(catchError(this.handleError));
  }

  public getById(id: number): Observable<CreateMotivoTransicaoResponse> {
    return this.httpClient
      .get<CreateMotivoTransicaoResponse>(`${this.apiUrl}/idMotivoTransicao/${id}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public create(request: MotivoTransicaoRequest): Observable<CreateMotivoTransicaoResponse> {
    return this.httpClient
      .post<CreateMotivoTransicaoResponse>(this.apiUrl, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public update(id: number, request: MotivoTransicaoRequest): Observable<CreateMotivoTransicaoResponse> {
    return this.httpClient
      .put<CreateMotivoTransicaoResponse>(
        `${this.apiUrl}/idMotivoTransicao/${id}`,
        request,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public toggleAtivo(id: number, request: MotivoTransicaoAtivoRequest): Observable<ReturnStruct> {
    return this.httpClient
      .put<ReturnStruct>(`${this.apiUrl}/idMotivoTransicao/${id}/ativo`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public deleteBulk(ids: number[]): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(`${this.apiUrl}/bulk-delete`, { ids }, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
